export default "__VITE_ASSET__ge72yaS7__"